<template>
  <el-dialog
      title="编辑房屋数据"
      :visible.sync="houstDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="1200px"
      center>
    <el-form :model="houstForm" :rules="rules" ref="houstForm" label-width="120px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="社区：" prop="project">
            <el-input :value="project" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="小区：" prop="community">
            <el-input :value="community" readonly></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="楼门户：" prop="room">
            <el-input :value="room" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="户主：" prop="name">
            <el-input :value="name" readonly placeholder="请在居民数据中修改"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="手机号：" prop="phone">
            <el-input :value="phone" readonly placeholder="请在居民数据中修改"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="房屋面积：" prop="phone">
            <el-input type="number" v-model="houstForm.mianji" placeholder="请输入房屋面积">
              <template slot="append">平米</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="房屋性质：" prop="housingNature">
            <el-select v-model="houstForm.housingNature" class="w-all" placeholder="请选择">
              <el-option
                  v-for="item in housingNatureList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="居住情况：" prop="liveSituation">
            <el-select v-model="houstForm.liveSituation" class="w-all" placeholder="请选择">
              <el-option
                  v-for="item in liveSituationList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="综改调查：" prop="reform">
            <el-select v-model="houstForm.reform" class="w-all" placeholder="请选择">
              <el-option
                  v-for="item in reformList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="物业合同：" prop="contract">
            <el-select v-model="houstForm.contract" class="w-all" placeholder="请选择">
              <el-option
                  v-for="item in contractList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注：" prop="desc">
            <el-input type="textarea" v-model="houstForm.desc" placeholder="请输入备注"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item class="flex align-center justify-around" label-width="0">
        <el-button class="padding-lr-xl" @click="resetForm('houstForm')">取消</el-button>
        <el-button class="padding-lr-xl" type="primary" @click="submitForm('houstForm')">提交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {roomUpdate} from "@/api/houst";
import {
  optionList,
  housingNature,
  liveSituation,
  reform,
  contract
} from "@/utils/utils";

export default {
  name: "houstDialog",
  props: {
    houstDialog: {
      type: Boolean,
      default: false
    },
    setId: {
      type: Number,
      default() {
        return 0;
      }
    },
    setItem: {
      type: Object
    }
  },
  data() {
    return {
      project: '',
      community: '',
      room: '',
      name: '',
      phone: '',
      housingNatureList: optionList(false, housingNature),
      liveSituationList: optionList(false, liveSituation),
      reformList: optionList(false, reform),
      contractList: optionList(false, contract),
      houstForm: {
        mianji: '',
        housingNature: '',
        liveSituation: '',
        reform: '',
        contract: '',
        desc: ''
      },
      rules: {
        mianji: [{required: true, message: '请输入房屋面积', trigger: 'blur'}],
        housingNature: [{required: true, message: '请选择房屋性质', trigger: 'change'}],
        liveSituation: [{required: true, message: '请选择居住情况', trigger: 'change'}],
        reform: [{required: true, message: '请选择综改调查', trigger: 'change'}],
        contract: [{required: true, message: '请选择物业合同', trigger: 'change'}],
        register: [{required: true, message: '请输入户籍地', trigger: 'blur'}],
      }
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit('cancelDialog', false)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      let _state = await roomUpdate(
          this.houstForm.housingNature,
          this.houstForm.mianji,
          this.houstForm.liveSituation,
          this.houstForm.reform,
          this.houstForm.contract,
          this.houstForm.desc,
          this.setId ? this.setId : '',
      );
      this.$message.success(_state.info);
      this.$refs[formName].resetFields();
      this.$emit("cancelDialog", true);
    }
  },
  // this.setItem.
  watch: {
    setItem() {
      this.project = this.setItem.xiangmu_name
      this.community = this.setItem.xiaoqu_name
      this.room = this.setItem.building_name + '-'+  this.setItem.element_name +'-'+  this.setItem.room_name
      this.name = this.setItem.huzu_name
      this.phone = this.setItem.huzu_phone
      this.houstForm = {
        mianji: this.setItem.mianji,
        housingNature: this.setItem.xingzhi,
        liveSituation: this.setItem.juzhu_qingkuang,
        reform: this.setItem.zonggai,
        contract: this.setItem.wuyehetong,
        desc: this.setItem.beizhu
      };
      this.$nextTick(() => {
        this.$refs['houstForm'].clearValidate();
      })
    }
  }
}
</script>

<style scoped lang="scss">

</style>